var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5.99985C13 5.44495 12.5523 5 12 5C11.4439 5 11 5.44765 11 5.99985V11H5.99985C5.44495 11 5 11.4477 5 12C5 12.5561 5.44765 13 5.99985 13H11V18.0001C11 18.5551 11.4477 19 12 19C12.5561 19 13 18.5524 13 18.0001V13H18.0001C18.5551 13 19 12.5523 19 12C19 11.4439 18.5524 11 18.0001 11H13V5.99985Z",
    fill: "#181A19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.e1f5d0dbab5e863518c6d5497563f3ae.svg";
export { ForwardRef as ReactComponent };